<app-ace-select [items]="options"
                [bindValue]="valueKey"
                [bindLabel]="labelKey"
                [placeholder]="placeholder() ?? ('Status' | messageTranslate)"
                [multiSelect]="multiSelect()"
                [hideSelected]="false"
                [appendTo]="DROPDOWN_HOLDER_SELECTOR"
                [maxSelectedLabels]="this.maxSelectedLabels()"
                [maxSelectedShowItemName]="true"
                [maxSelectedItemName]="{messageKey: 'statuses'}"
                [showClearItem]="true"
                [truncateLabels]="true"
                (openEvent)="onOpenEvent($event)"
                (closeEvent)="onCloseEvent($event)"/>
